/* src/app/pages/banner/banner.component.css */
.ratio-16x9 {
  position: relative;
  width: 100%;
  max-height: 320px;
  overflow: hidden;
}
.ratio-16x9 iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
@media (min-width: 1200px) {
  .ratio-16x9 {
    max-height: 350px;
  }
}
@media (max-width: 980px) {
  .ratio-16x9 {
    max-height: 300px;
  }
}
@media (max-width: 800px) {
  .ratio-16x9 {
    max-height: 250px;
  }
}
@media (max-width: 650px) {
  .ratio-16x9 {
    max-height: 210px;
  }
}
@media (max-width: 475px) {
  .ratio-16x9 {
    max-height: 250px;
  }
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/banner.component.css.map */
